"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_INFO_SIZE = exports.TEXT_INFO_SEGMENT = exports.TEXT_INFO_KIND = exports.TEXT_INFO_HEADING_LEVEL = exports.TEXT_INFO_FONT_WEIGHT = exports.TEXT_INFO_DISPLAY = exports.TEXT_INFO_DECORATION = exports.TEXT_INFO_COLOR = exports.TEXT_INFO_BORDER = exports.TEXT_INFO_ALIGN = void 0;
/* eslint-disable prettier/prettier  */
// React
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
// genero version
// Components
const span_1 = __importDefault(require("./span"));
const paragraph_1 = __importDefault(require("./paragraph"));
const heading_1 = __importDefault(require("./heading"));
const utils_1 = require("./utils");
// Enums
const enums_1 = require("./enums");
Object.defineProperty(exports, "TEXT_INFO_ALIGN", { enumerable: true, get: function () { return enums_1.TEXT_INFO_ALIGN; } });
Object.defineProperty(exports, "TEXT_INFO_BORDER", { enumerable: true, get: function () { return enums_1.TEXT_INFO_BORDER; } });
Object.defineProperty(exports, "TEXT_INFO_COLOR", { enumerable: true, get: function () { return enums_1.TEXT_INFO_COLOR; } });
Object.defineProperty(exports, "TEXT_INFO_DECORATION", { enumerable: true, get: function () { return enums_1.TEXT_INFO_DECORATION; } });
Object.defineProperty(exports, "TEXT_INFO_DISPLAY", { enumerable: true, get: function () { return enums_1.TEXT_INFO_DISPLAY; } });
Object.defineProperty(exports, "TEXT_INFO_FONT_WEIGHT", { enumerable: true, get: function () { return enums_1.TEXT_INFO_FONT_WEIGHT; } });
Object.defineProperty(exports, "TEXT_INFO_HEADING_LEVEL", { enumerable: true, get: function () { return enums_1.TEXT_INFO_HEADING_LEVEL; } });
Object.defineProperty(exports, "TEXT_INFO_KIND", { enumerable: true, get: function () { return enums_1.TEXT_INFO_KIND; } });
Object.defineProperty(exports, "TEXT_INFO_SEGMENT", { enumerable: true, get: function () { return enums_1.TEXT_INFO_SEGMENT; } });
Object.defineProperty(exports, "TEXT_INFO_SIZE", { enumerable: true, get: function () { return enums_1.TEXT_INFO_SIZE; } });
/**
 * @name TextInfo
 * @description atomic component
 * @see {@link https://bit.dev/gerenciatd/unifiedcomponents/text-info}
 * @param {any} props
 * @returns {React.FC}
 */
//  
const COMPONENT_NAME = "TextInfo";
const TextInfo = (_a) => {
    var { className, segment: segmentProp, kind, text, cyData, custoObjectInfo } = _a, restProps = __rest(_a, ["className", "segment", "kind", "text", "cyData", "custoObjectInfo"]);
    let componentClassName = 'text-info';
    if (className) {
        componentClassName = `${componentClassName} ${className}`;
    }
    const segment = (0, utils_1.getSegment)(segmentProp);
    let editModal = null;
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
        componentClassName = `${componentClassName} custo-editable`;
    }
    const Cmp = {
        [enums_1.TEXT_INFO_KIND.HEADING]: heading_1.default,
        [enums_1.TEXT_INFO_KIND.PARAGRAPH]: paragraph_1.default,
        [enums_1.TEXT_INFO_KIND.SPAN]: span_1.default,
    }[kind] || span_1.default;
    return (react_1.default.createElement(Cmp, Object.assign({ className: componentClassName }, restProps, { segment: segment, kind: kind, text: text, cydata: cyData, onClick: editModal })));
};
TextInfo.propTypes = {
    className: prop_types_1.default.string,
    kind: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_KIND)),
    level: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_HEADING_LEVEL)),
    text: prop_types_1.default.string.isRequired,
    color: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_COLOR)),
    size: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_SIZE)),
    fontType: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_FONT_WEIGHT)),
    align: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_ALIGN)),
    display: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_DISPLAY)),
    backgroundColor: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_COLOR)),
    decoration: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_DECORATION)),
    border: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_BORDER)),
    cyData: prop_types_1.default.string,
    custoInfo: prop_types_1.default.shape({
        componentId: prop_types_1.default.string,
        componentInstance: prop_types_1.default.string,
        editFunction: prop_types_1.default.func,
    })
};
TextInfo.defaultProps = {
    kind: enums_1.TEXT_INFO_KIND.SPAN,
    size: enums_1.TEXT_INFO_SIZE.CAPTION2,
    color: enums_1.TEXT_INFO_COLOR.BLACK,
    fontType: enums_1.TEXT_INFO_FONT_WEIGHT.REGULAR,
    cyData: '',
    custoInfo: null,
};
exports.default = TextInfo;
//# sourceMappingURL=index.js.map